'use client';
import type { ReactElement } from 'react';
import { motion } from 'framer-motion';
import { ButtonPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { Cbutton } from '../Cbutton';
import { Ctext } from '../Ctext';
import { CONTROLS_ANIMATION, HeroCarouselControlsAnimationEvent, type HeroCarouselControlsAnimationEventHandler, HeroCarouselControlsViewport, } from './Cherocarouselcontrols.constants';
import { notifyHeroCarouselControlsAnimationEvent, resolveHeroCarouselControlsBuildAllAnimation, resolveHeroCarouselControlsTransition, } from './Cherocarouselcontrols.motion';
interface BuildAllControlsProps {
    controlsViewport: HeroCarouselControlsViewport;
    shouldShowControls: boolean;
    controlsEntranceDelay: number;
    onBuildYourOwn?: () => void;
    onAllTeams?: () => void;
    onAnimationEvent?: HeroCarouselControlsAnimationEventHandler;
}
const BUILD_ALL_TEXT_SIZE_BY_VIEWPORT: Record<HeroCarouselControlsViewport, number> = {
    [HeroCarouselControlsViewport.Mobile]: 20.8,
    [HeroCarouselControlsViewport.Desktop]: 22,
};
const BUILD_ALL_MARGIN_TOP_BY_VIEWPORT: Record<HeroCarouselControlsViewport, string | undefined> = {
    [HeroCarouselControlsViewport.Mobile]: '10px',
    [HeroCarouselControlsViewport.Desktop]: undefined,
};
export function BuildAllControls({ controlsViewport, shouldShowControls, controlsEntranceDelay, onBuildYourOwn, onAllTeams, onAnimationEvent, }: BuildAllControlsProps): ReactElement {
    return <motion.div initial={{ opacity: 0, y: -CONTROLS_ANIMATION.buildYourOwnDistance }} animate={resolveHeroCarouselControlsBuildAllAnimation({ shouldShowControls })} onAnimationStart={() => {
            notifyHeroCarouselControlsAnimationEvent({
                onAnimationEvent,
                eventName: HeroCarouselControlsAnimationEvent.BuildAllStart,
            });
        }} onAnimationComplete={() => {
            notifyHeroCarouselControlsAnimationEvent({
                onAnimationEvent,
                eventName: HeroCarouselControlsAnimationEvent.BuildAllComplete,
            });
        }} transition={resolveHeroCarouselControlsTransition({
            shouldShowControls,
            controlsEntranceDelay,
        })} style={{
            display: 'flex',
            marginTop: BUILD_ALL_MARGIN_TOP_BY_VIEWPORT[controlsViewport],
            alignItems: 'center',
        }}>
	            <Cbutton preset={ButtonPreset.Ghost} onClick={onBuildYourOwn}>
	                <Ctext size={BUILD_ALL_TEXT_SIZE_BY_VIEWPORT[controlsViewport]} color={ColorType.White} weight={FontWeight.SemiBold} opacity={0.7}>
                    Build Your Own
                </Ctext>
            </Cbutton>
	            <Ctext>•</Ctext>
	            <Cbutton preset={ButtonPreset.Ghost} onClick={onAllTeams}>
	                <Ctext size={BUILD_ALL_TEXT_SIZE_BY_VIEWPORT[controlsViewport]} color={ColorType.White} weight={FontWeight.SemiBold} opacity={0.7}>
                    All Teams
                </Ctext>
            </Cbutton>
        </motion.div>
        ;
}
